module.exports = __webpack_public_path__ + "img/indent.0994bdd6.svg";